import React, { useState, useEffect, useRef } from 'react'
import { MenuItem } from 'material-ui'
import styled from 'styled-components'
import { HardwareKeyboardArrowDown } from 'material-ui/svg-icons'

const InlineSelect = ({
  label,
  onChange,
  value: defaultValue,
  options,
  cypress_id,
  disabled,
  name,
  openType = 'absolute',
}) => {
  const inlineSelectRef = useRef(null)
  const [value, setValue] = useState(defaultValue)
  const [open, setOpen] = useState(false)

  const handleSetOption = (event, index, value) => {
    setOpen(false)
    setValue(value)
    onChange(event, index, value)
  }

  useEffect(() => {
    value !== defaultValue && setValue(defaultValue)
  }, [defaultValue])

  useEffect(() => {
    const closeInlineSelect = e => {
      if (
        inlineSelectRef.current &&
        !inlineSelectRef.current.contains(e.target)
      ) {
        setOpen(false)
      }
    }
    document.addEventListener('click', closeInlineSelect)
    return () => {
      document.removeEventListener('click', closeInlineSelect)
    }
  }, [inlineSelectRef])

  return (
    <SelectWrapper>
      <label>{label}:</label>
      <div
        ref={inlineSelectRef}
        class={`select-field ${open ? 'open' : ''} ${
          disabled ? 'disabled' : ''
        } ${openType}`}
        cypress_id={cypress_id}
        onClick={() => (open || disabled ? null : setOpen(true))}
        name={name}
      >
        <div className="options">
          {options.map(
            (option, idx) =>
              (open || (!open && option.value === value)) && (
                <MenuItem
                  key={idx}
                  primaryText={option.label}
                  value={option.value}
                  disabled={option.disabled}
                  leftIcon={option.icon}
                  cypress_id={`${cypress_id}-menu-item`}
                  className={`${option.icon ? 'icon' : ''}`}
                  onClick={(event, index) =>
                    open ? handleSetOption(event, index, option.value) : null
                  }
                />
              ),
          )}
          {!open && <HardwareKeyboardArrowDown />}
        </div>
      </div>
    </SelectWrapper>
  )
}

const SelectWrapper = styled.div`
  width: 100%;
  position: relative;
  .select-field {
    border: none !important;
    width: 100% !important;
    position: relative;
    .options {
      min-height: 50px;
      max-height: 250px;
      overflow: auto;
      width: 100%;
      background: ${props => props.theme.colors.alabaster} !important;
      ${props =>
        props.bgTransparent && 'background-color: transparent !important;'}
    }
    &.open {
      z-index: 2;
    }
    &.absolute {
      margin-bottom: 60px;
      .options {
        position: absolute;
        top: 0;
        left: 0;
      }
    }
    &.relative {
      position: relative;
    }
    &.disabled {
      > div.options {
        > div {
          > span {
            > div {
              > div {
                color: ${props => props.theme.colors.darkAthensGray} !important;
                cursor: not-allowed;
              }
            }
          }
        }
      }
    }
    > div.options {
      > div {
        > span {
          &.icon {
            > div {
              > div {
                padding-left: 50px !important;
              }
            }
          }
          > div {
            > div {
              font-size: ${props =>
                props.theme.fontSizes.materialUI.selectField} !important;
              color: ${props => props.theme.colors.secondary} !important;
              font-weight: initial !important;
            }
          }
        }
      }
    }
  }

  svg {
    position: absolute;
    width: 13px;
    height: 100%;
    right: 3px;
    top: 13px;
    z-index: ${props => props.theme.zIndexes.mainContentWrapper.first};
    pointer-events: none;
  }

  label {
    display: block;
    padding: 0;
    font-size: ${props => props.theme.fontSizes.form.label};
    color: ${props => props.theme.colors.secondary};
    font-family: ${props => props.theme.fonts.robotoRegular};
    line-height: 24px;
    margin: 0 0 10px 0;
  }
`

export default InlineSelect
